module.exports = __webpack_public_path__ + "static/media/Ahmed Abou Alfa.611d86be.jpg";